/**
 * What a viewer keys on: the file version, never the link. A renewed
 * presigned URL for the same bytes must not remount an `<img>`, restart a
 * `<video>` or refetch a body. `content_hash` names the bytes exactly;
 * `updated_at` stands in for rows that carry none (links, previews).
 */
export function fileRecordVersionKey(record: {
  path?: string | null;
  content_hash?: string | null;
  updated_at?: string | null;
}): string {
  return `${record.path ?? ""}#${record.content_hash || record.updated_at || ""}`;
}
